import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { tiposDialog } from 'app/core/data/forms.json';
import { selectDialog } from 'app/core/interfaces/authorization.types';
import { DialogData } from 'app/core/interfaces/dialog';
import { FormComponent } from 'app/pages/home/home.component';
import { FormDirective } from 'app/core/directives/form-directive';

@Component({
  selector: 'page-dialog',
  templateUrl: 'dialog.html',
  styleUrls: ['./dialog.scss']
})

export class MaterialDialog {

  @ViewChild(FormDirective, {static: true}) formHost!: FormDirective;
  public tipos:selectDialog[]  = tiposDialog;

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    if (data.component) {
     // this.loadComponent(data.component, data.param);
    }
  }

  // dismiss(): void {
  //   this.dialogRef.close();
  // }  

  loadComponent(tipo: string, data?:any) {;
    const formItem = this.tipos.find((item: selectDialog) => item.id == tipo);
    
    if (formItem?.component){
      const viewContainerRef = this.formHost.viewContainerRef;
      viewContainerRef.clear();
  
      const componentRef = viewContainerRef.createComponent<FormComponent>(formItem.component);
      componentRef.instance.data = data ? data : {};
    } 
  }
}
